export const STATUS_MAPPING = {
	Submitted: "Submitted",
	"Under Process": "Under Review",
	"Pending Revision": "Revision Required",
	Processed: ["Rejected", "Approved"],
};

export const PUBLICATION_STATUS_MAPPING = {
	Submitted: "Submitted",
	"Under Process": "Under Review",
	"Pending Revision": "Revision Required",
	Processed: "Reviewed",
};

export const PUBLICATION_TYPE_MAP = {
	ABS: "Abstract",
	SUM: "Summary",
	RES: "Research Paper",
	MAN: "Manuscript",
};

export const JOUORCONMAP = {
	JOU: "Journal",
	CON: "Conference",
};

export const SERVICE_REQUEST_REVIEW = [
	{
		value: "UNDER_REVIEW",
		name: "Under Review",
	},
	{
		value: "REVISION",
		name: "Revision Required",
	},
	{
		value: "APPROVED",
		name: "Approved",
	},
	{
		value: "REJECTED",
		name: "Rejected",
	},
];

export const SERVICE_REQUEST_TYPE_DATA = "DATA";
export const SERVICE_REQUEST_TYPE_HARDWARE = "HARDWARE";
export const SERVICE_REQUEST_TYPE_SOFTWARE = "SOFTWARE";
export const SERVICE_REQUEST_TYPE_FILEIMPORT = "FILEIMPORT";
export const SERVICE_REQUEST_TYPE_OUTPUT = "OUTPUT";
export const SERVICE_REQUEST_TYPE_PUBLICATION = "PUBLICATION";
